import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAppContext } from '../Context';
import { useTranslation } from '../TranslationContext';
import { motion } from 'framer-motion';

const Success = () => {
	const { submittedCode, paymentID, paymentSuccess } = useAppContext();
	const { t } = useTranslation();
	const navigate = useNavigate();

    useEffect(() => {
		var navigateTo = `/?qr=${submittedCode}`;
		if (submittedCode === null) {
			navigateTo = '/';
		}
		setTimeout(function(){navigate(navigateTo)}, 5000);
    });

	return (
		<div className="paymentMessage">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, ease: "easeInOut" }}
			>
				{paymentSuccess ? (
					<h1>{t('paymentSuccess')}</h1>
				) : (
					<h1>{t('paymentFailed')}</h1>
				)}
				<h3>{t('paymentMessageRedirect')}</h3>
				<p>{t('paymentMessage1a')} <a href={`/?qr=${submittedCode}`}>{t('paymentMessage1b')}</a></p>
			</motion.div>
		</div>
	);
};

export default Success;